module.exports = __webpack_public_path__ + "static/media/overall.b87d4402.png";